import {
  ChangeDetectionStrategy,
  Component,
  Input,
  inject,
} from '@angular/core';
import { Store } from '@ngxs/store';
import { TimelineShift } from '@wilson/interfaces';
import { DropZoneEventThrottlerDirective } from '@wilson/shift-timeline/assignments-gantt-chart';
import { CreateNewViaDragAndDropService } from '@wilson/shift-timeline/services';
import {
  TimelineRemoveShiftFromUserV2,
  TimelineStaysSuggestionService,
} from '@wilson/shift-timeline/state';
import { firstValueFrom } from 'rxjs';
import { ShiftTemplateHelperService } from '../../components/shift-template-drop-zone/shift-template-helper.service';
import { ShiftTemplateDropZoneHelperService } from './shift-template-drop-zone-helper.service';
import { TimelineCellHighlightService } from '@wilson/shift-timeline/assignments-gantt-chart';

@Component({
  selector: 'wilson-shift-template-drop-zone-v2',
  imports: [],
  template: '',
  styleUrls: ['./shift-template-drop-zone-v2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ShiftTemplateDropZoneV2Component extends DropZoneEventThrottlerDirective {
  private readonly store = inject(Store);
  protected timelineStaysSuggestionService = inject(
    TimelineStaysSuggestionService,
  );
  private readonly shiftTemplateDropZoneHelperService = inject(
    ShiftTemplateDropZoneHelperService,
  );
  private readonly shiftTemplateHelperService = inject(
    ShiftTemplateHelperService,
  );
  private readonly timelineCellHighlightService = inject(
    TimelineCellHighlightService,
  );

  @Input() userId!: string | undefined;
  private shiftStartDate!: Date;

  private mockShiftWithoutActivities!: TimelineShift | null;

  protected override onDragOverHandler(offsetX: number) {
    this.timelineCellHighlightService.clearCellsFromHighlight();
    const processResult =
      this.shiftTemplateDropZoneHelperService.handleOnDragOverProcess({
        offsetX,
        userId: this.userId,
      });
    if (processResult) {
      this.shiftStartDate = processResult.shiftStartDate;
      this.mockShiftWithoutActivities =
        processResult.mockShiftWithoutActivities;
      this.timelineCellHighlightService.setCellToHighlight(
        this.userId as string,
        processResult.shiftStartDate.toISOString(),
      );
    }
  }

  protected override onDragLeaveHandler() {
    if (this.userId) {
      this.store.dispatch(
        new TimelineRemoveShiftFromUserV2({
          userId: this.userId,
          shiftId: CreateNewViaDragAndDropService.MOCK_SHIFT_ID,
        }),
      );
    }
    this.timelineCellHighlightService.clearCellsFromHighlight();
  }

  protected override async onDropHandler() {
    const shiftTemplate = await firstValueFrom(
      this.shiftTemplateHelperService.shiftTemplate$,
    );
    this.shiftTemplateDropZoneHelperService.handleOnDropProcess({
      shiftTemplate,
      shiftStartDate: this.shiftStartDate,
      userId: this.userId,
      mockShiftWithoutActivities: this.mockShiftWithoutActivities,
    });
    this.timelineCellHighlightService.clearCellsFromHighlight();
  }
}
